<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails du paiement de masse</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <div class="text-center mb-3">
              <d-badge outline pill :theme="badge">{{ status_fr }}</d-badge>
            </div>
            <c-input :disabled="!is_editable" container-class="mb-0" type="select"
                     label="Changer le statut du paiement ?" :options="status_options"
                     v-model="status" :state="status_state">
              <template slot="first">
                <option :value="null">Sélectionnez un statut</option>
              </template>
              Veuillez sélectionner un statut
            </c-input>
            <c-input type="textarea" container-class="mb-3 mt-3" label="Message" v-model="message"
                     :state="message_state" :disabled="!status">
              Veuillez saisir un message
            </c-input>
            <c-input type="datetime" container-class="mb-3" label="Créé le" :value="created_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Planifié le" :value="scheduled_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Débuté le" :value="started_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Terminé le" :value="terminated_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Dernière modification" :value="updated_at" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input container-class="mb-3" label="Service" :value="service" disabled/>
            <c-input container-class="mb-3" label="Liste de paiement" :value="payment_list.name" disabled/>
            <c-input container-class="mb-3" label="Type de fichier" :value="payment_list.filetype" disabled/>
            <b-form-group>
              <label class="font-weight-bold mb-0">Fichier des bénéficiaires</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="payment_list.original_filename" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="payment_list.file" target="_blank">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <c-input type="filename" :extension="progress.rate" container-class="mb-3" label="Progression"
                     :value="progress.value" disabled/>
            <c-input type="filename" :extension="success.rate" container-class="mb-3" label="Succès"
                     :value="success.value" disabled/>
            <c-input type="filename" extension="FCFA" container-class="mb-3" label="Total payé" :value="total_paid"
                     disabled/>
            <c-input type="textarea" container-class="mb-3" label="Motif" :value="reason" disabled/>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner v-if="is_editable" class="mr-2" variant="danger" :fetching="fetchingFormSubmit"
                          @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-exclamation-triangle"></i>
          </template>
          Changer le statut
        </c-button-spinner>
        <b-button variant="secondary" class="ml-2" @click="onModalClose">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>

    <div>
      <!-- COLLAPSE-->
      <b-button v-b-toggle.collapse-2 class="m-1 greenbutton">
        <i class="fas fa-filter mr-2 "></i> Recherche avancée
      </b-button>

      <!-- Element to collapse -->
      <b-collapse id="collapse-2" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="px-4 pb-0">
            <b-row>
              <d-input-group class="justify-content-center">
                <c-input label="Du" type="date" class="mr-5" v-model="startDate"/>
                <c-input label="Au" type="date" class="mr-5" v-model="endDate"/>
                <c-input label="Mot clé de recherche" class="mr-5" placeholder="Rechercher..." v-model="search"/>
                <c-input type="select" label="Rechercher par statut" class="mr-5" :options="status_options"
                         v-model="searchStatus">
                  <template slot="first">
                    <option :value="null">Sélectionnez un statut</option>
                  </template>
                </c-input>
              </d-input-group>
            </b-row>
            <b-row class="justify-content-center">
              <c-button-spinner class="inline-btn ml-1 mb-3" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Rechercher
              </c-button-spinner>
            </b-row>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>

    <d-card class="card-small">
      <d-card-body class="pt-5">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucun paiement de masse trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, formatAmount, formatPercent, Regex, Toast} from "@/helpers"

export default {
  title: "Paiements de masse",
  data() {
    return {
      search: '',
      fetchingSearch: false,
      startDate: "",
      endDate: "",
      searchStatus: null,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'payment_list', label: 'Liste de paiement', sortable: true},
        {key: 'service_name', label: 'Service', sortable: true},
        {key: 'progress', label: 'Progression', sortable: true},
        {key: 'success', label: 'Succès', sortable: true},
        {key: 'total_paid', label: 'Total payé', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'created_at_pretty', label: 'Créé le', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {
          type: 'white',
          icon: 'fas fa-exchange-alt',
          title: "Liste des transactions",
          handler: this.onRedirectToTransaction
        },
        {type: 'white', icon: 'fa fa-download', title: "Télécharger le rapport", handler: this.onDownloadReport},
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails du paiement", handler: this.onItemSelect},
      ],

      modalVisible: false,

      selectedItem: null,

      status_options: [],
      status: null,
      message: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return (!this.searchStatus || this.searchStatus === item.payment_status)
          && (
            item.service_name.toLowerCase().includes(search)
            || item.payment_list.toLowerCase().includes(search)
            || item.reason.toLowerCase().includes(search)
            || item.original_filename.toLowerCase().includes(search)
          )
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    is_editable() {
      return this.auth.isAdmin && this.itemSelected
        && !['TERMINATED', 'CANCELED'].includes(this.selectedItem.payment_status)
    },
    status_fr() {
      return this.itemSelected ? this.selectedItem.status_fr : ''
    },
    badge() {
      return this.itemSelected ? this.selectedItem.badge : ''
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ''
    },
    scheduled_at() {
      return this.itemSelected ? this.selectedItem.scheduled_at : ''
    },
    started_at() {
      return this.itemSelected ? this.selectedItem.started_at : ''
    },
    terminated_at() {
      return this.itemSelected ? this.selectedItem.terminated_at : ''
    },
    updated_at() {
      return this.itemSelected ? this.selectedItem.updated_at : ''
    },
    service() {
      return this.itemSelected ? this.selectedItem.service_name : ''
    },
    payment_list() {
      return this.itemSelected ? this.selectedItem.bulk_payment_list : {}
    },
    progress() {
      if (!this.itemSelected) return ''

      const parts = this.selectedItem.progress.split('\n')
      return {value: parts[0], rate: parts[1]}
    },
    success() {
      if (!this.itemSelected) return ''

      const parts = this.selectedItem.success.split('\n')
      return {value: parts[0], rate: parts[1]}
    },
    total_paid() {
      return this.itemSelected ? this.selectedItem.total_paid : ''
    },
    reason() {
      return this.itemSelected ? this.selectedItem.reason : ''
    },
    status_state() {
      return !this.submitted || Regex.isNotEmpty(this.status)
    },
    message_state() {
      return !this.submitted || true
    },
  },
  created() {
    this.fetchingData = true

    Api.get('/bulk_payment/states')
      .then(res => this.status_options = res.data.bulk_payment_states)
      .catch(err => this.error = err)
      .then(() => null)

    Api.get('/bulk_payment/list')
      .then(res => {
        const data = res.data.bulk_payments
        if (data)
          this.data = data.map(this.mapItem)
        else
          Toast.info("Aucun paiement trouvé")
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        payment_list: item.bulk_payment_list.name,
        service_name: item.service.name,
        progress: `${formatAmount(item.terminated_transactions)} / ${formatAmount(item.total_items)}\n${formatPercent(item.terminated_transactions, item.total_items)}`,
        success: `${formatAmount(item.success_transactions)} / ${formatAmount(item.terminated_transactions)}\n${formatPercent(item.success_transactions, item.terminated_transactions)}`,
        total_paid: `${formatAmount(item.paid_amount)} / ${formatAmount(item.total_amount)}`,
        payment_status: item.status,
        status: item.status_fr,
        statusVariant: item.badge,
        created_at_pretty: item.created_at.replace(' ', '\n')
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true
      this.message = item.message
    },
    clearFields() {
      this.status = null
      this.message = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.modalVisible = false
      this.clearFields()
    },
    isFormValid() {
      return this.status_state && this.message_state
    },
    onDownloadReport(item) {
      Toast.loading(`Génération du rapport de paiement...`)
      Api.download('/bulk_payment/download_report', {
        bulk_payment_id: item.id,
      })
        .then(res => {
          console.log(res.headers)
          Toast.success(`Le rapport de paiement a été généré avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
    onFormSubmit() {
      this.submitted = true
      if (!this.isFormValid()) return

      const description = `paiement de ${formatAmount(this.selectedItem.total_amount)} XAF aux bénéficiaires de la liste ${this.selectedItem.payment_list}`
      const ans = prompt(`Veuillez saisir "${this.status}" pour changer le statut du ${description}.`)
      if (ans !== this.status) return

      this.fetchingFormSubmit = true
      Api.postFormData('/bulk_payment/change_status', {
        bulk_payment_id: this.selectedItem.id,
        status: this.status,
        message: this.message,
      })
        .then(res => {
          const bulk_payment = this.mapItem(res.data.bulk_payment)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, bulk_payment)

          this.onModalClose()

          Toast.success(`Le statut du ${description} a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onSearchSubmit() {
      this.data = []
      this.fetchingSearch = true
      Api.get('/bulk_payment/find', {
        search: this.search,
        start_date: this.startDate,
        end_date: this.endDate,
        status: this.searchStatus
      })
        .then((res) => {
          const data = res.data.bulk_payments
          if (data)
            this.data = data.map(this.mapItem)
          else
            Toast.info("Aucun paiement de masse trouvé")
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    onRedirectToTransaction(item) {
      this.$router.push({name: 'transactions', query: {entity: 'BULK', id: item.id}});
    },
  }
}
</script>
